<template>
  <div class="home-wrapper">
    <header>
      <swiper
        class="swiper"
        :options="swiperOption"
      >
        <swiper-slide
          v-for="(item,index) in bannerList"
          :key="index"
        >
          <a
            :href="item.jump_url"
            target="_blank"
            v-if="item.jump_url"
          >
            <img
              :src="item.logo_url"
              alt=""
            >
          </a>
          <img
            :src="item.logo_url"
            alt=""
            v-else
          >
        </swiper-slide>
        <div
          class="swiper-pagination"
          slot="pagination"
        ></div>
      </swiper>
    </header>
    <section>
      <!--新闻播报-->
      <div class="news_broadcast">
        <Broadcast @clickNotice="clickNotice"></Broadcast>
      </div>
      <!--点击公告弹出文章-->
      <Article
        v-if="showArticle"
        @clickNotice="clickNotice"
        :noticeContent="noticeContent"
      ></Article>
      <div class="side">
        <div class="wraps clearfix">
          <div class="waybill">
            <div class="searchBox">
              <textarea
                name=""
                id=""
                cols="30"
                rows="10"
                placeholder="请输入您的订单号进行查询"
                @change="billChange"
              ></textarea>
              <button @click="searchBill">立即查询</button>
            </div>
            <router-link to="/WaybillQuery">运单查询</router-link>
            <img
              src="../assets/icon.png"
              alt=""
            >
          </div>
          <div class="card">
            <dl>
              <dt>
                <img
                  src="../assets/zheng1.png"
                  alt=""
                >
                <img
                  src="../assets/zheng2.png"
                  alt=""
                >
              </dt>
              <dd>
                <ol>
                  <li>身份证用来做清关使用；</li>
                  <li>您需要提供身份证正反面，点击可以进入上传页面，也可以添加微信公众号直接发送图片；</li>
                  <li>上传证件成功后可自动识别信息</li>
                </ol>
              </dd>
            </dl>
            <router-link to="/IdCardUpload">身份证上传</router-link>
            <img
              src="../assets/icon1.png"
              alt=""
            >
          </div>
          <div
            class="user"
            v-if="isload"
          >
            <div class="userLoad">
              <input
                type="text"
                placeholder="手机号/用户名"
                v-model="user.tel"
              >
              <input
                type="password"
                placeholder="密码"
                v-model="user.pwd"
              >
              <div class="btn">
                <router-link
                  to="/UserRegistration"
                  class="register"
                >注册</router-link>
                <p
                  @click="userLogin"
                  style="cursor:pointer"
                  class="login"
                >登录</p>
              </div>
              <div class="agreeService">
                <input
                  type="checkbox"
                  name="cookie"
                  value="2"
                >
                委托业务发生即代表您同意我们的
                <span
                  style="color: red;cursor: pointer"
                  @click="openServiceAgreement"
                >《服务协议》</span>
                和<span
                  style="color: red;cursor: pointer"
                  @click="openCookie"
                >《隐私政策》</span> ，
                服务协议包括
                <span class="underline-text">
                  <router-link to="/PageService?to=carrier">承运条款</router-link>
                </span>、
                <span class="underline-text">
                  <router-link to="/PageService?to=embargo">禁运物品</router-link>
                </span>、
                <span class="underline-text">
                  <router-link to="/PageService?to=compensation">赔付条款</router-link>
                </span> ;
                <!--<span class="underline-text"><router-link to="/PageService?to=pack">打包规则</router-link></span>；-->
              </div>
              <div style="border-top: 1px solid #dcdcdc;width: 80%;text-align: center;margin: 10px auto 0">
                <img
                  src="../assets/weixin .png"
                  alt=""
                  @click="getWxParam"
                  style="cursor:pointer"
                >
              </div>
            </div>
            <p @click="entry">网点用户入口</p>
            <img
              src="../assets/icon2.png"
              alt=""
            >
          </div>
          <div
            class="user"
            v-else
          >
            <div class="users">
              <p>{{userInfo.uid}}</p>
              <p>{{userInfo.nick_name}}</p>
              <span
                style="cursor:pointer"
                @click="order"
              >订单管理</span>
              <span
                @click="logout"
                style="cursor:pointer"
              >退出登录</span>
            </div>
            <div class="agreeService">
              <input
                type="checkbox"
                name="cookie"
                value="2"
              >
              委托业务发生即代表您同意我们的
              <span
                style="color: red;cursor: pointer"
                @click="openServiceAgreement"
              >《服务协议》</span>
              和<span
                style="color: red;cursor: pointer"
                @click="openCookie"
              >《隐私政策》</span> ，
              服务协议包括
              <span class="underline-text">
                <router-link to="/PageService?to=carrier">承运条款</router-link>
              </span>、
              <span class="underline-text">
                <router-link to="/PageService?to=embargo">禁运物品</router-link>
              </span>、
              <span class="underline-text">
                <router-link to="/PageService?to=compensation">赔付条款</router-link>
              </span>;
              <!--<span class="underline-text"><router-link to="/PageService?to=pack">打包规则</router-link></span>；-->
            </div>
            <p @click="entry">网点用户入口</p>
            <img
              :src="userInfo.avatar"
              alt=""
              v-if="userInfo.avatar"
            >
            <img
              src="../assets/icon2.png"
              alt=""
              v-else
            >
          </div>
        </div>
      </div>
      <div class="come">
        <div class="comeTop">
          <p>欢迎使用</p>
          <h2>速派国际物流</h2>
          <div></div>
        </div>
        <div class="comeType clearfix">
          <router-link
            to="/Business"
            @click.native="tabChange('supplier')"
          >
            <dl>
              <dt>
                <img
                  src="../assets/电商仓配.png"
                  alt=""
                >
              </dt>
              <dd>
                <p>电商仓配</p>
                <span>为电商提供一站式仓储配送服务以及保税业务</span>
              </dd>
            </dl>
          </router-link>
          <router-link
            to="/Business"
            @click.native="tabChange('container')"
          >
            <dl>
              <dt>
                <img
                  src="../assets/集运转运.png"
                  alt=""
                >
              </dt>
              <dd>
                <p>集运转运</p>
                <span>专注海外华人服务，仓库，配送，网购中国/日本/韩国商品一站式解决</span>
              </dd>
            </dl>
          </router-link>
          <router-link
            to="/Business"
            @click.native="tabChange('express')"
          >
            <dl>
              <dt>
                <img
                  src="../assets/快件.png"
                  alt=""
                >
              </dt>
              <dd>
                <p>快件进口和BC直购</p>
                <span>收费合理透明、清关快捷安全</span>
              </dd>
            </dl>
          </router-link>
          <router-link
            to="/Business"
            @click.native="tabChange('software')"
          >
            <dl>
              <dt>
                <img
                  src="../assets/软件.png"
                  alt=""
                >
              </dt>
              <dd>
                <p>软件服务支持</p>
                <span>严谨的研发团队，提供高效的软件服务</span>
              </dd>
            </dl>
          </router-link>
        </div>
      </div>
      <div class="strength">
        <div class="strengthBox">
          <div class="strengthTop">
            <h1>我们用实力证明</h1>
            <div></div>
          </div>
          <div class="strengthCont">
            <div>
              <p>500+</p>
              <p>遍布全球的员工</p>
              <p>遍布全球的国际企业，优秀员工来自各地</p>
            </div>
            <div>
              <p>+600K</p>
              <p>服务过的客户</p>
              <p>说得好不如做得好，大家好才是真的好</p>
            </div>
            <div>
              <p>99%</p>
              <p>客户好评率</p>
              <p>身正不怕影子斜，好评连连刷新高</p>
            </div>
            <div>
              <p>680</p>
              <p>合作企业</p>
              <p>一切以追求最好的资源，流行电子商务</p>
            </div>
          </div>
        </div>
      </div>
      <div class="chart">
        <swiper
          class="chartIcon"
          :options="swiperOptions"
          ref="mySwiper"
        >
          <swiper-slide>
            <img
              src="../assets/EMS.png"
              alt=""
            >
          </swiper-slide>
          <swiper-slide>
            <img
              src="../assets/FedEx.png"
              alt=""
            >
          </swiper-slide>
          <swiper-slide>
            <img
              src="../assets/dhl.png"
              alt=""
            >
          </swiper-slide>
          <swiper-slide>
            <img
              src="../assets/tnt-logo@2x.png"
              alt=""
            >
          </swiper-slide>
          <swiper-slide>
            <img
              src="../assets/supi.png"
              alt=""
            >
          </swiper-slide>
          <div
            class="swiper-pagination"
            slot="pagination"
          ></div>
        </swiper>
      </div>
    </section>
    <div
      class="qrcodeBox2"
      v-cloak
    >
      <div class="topbox">
        <div style='padding-right: 6px;'>
          <img
            :src="commonData?commonData.syycode[0].logo_url:''"
            alt=""
          >
          <div>扫码关注<span>公众号</span></div>
        </div>
        <div>
          <img
            :src="commonData?commonData.syyapp[0].logo_url:''"
            alt=""
          >
          <div>扫描二维码<span></span></div>
          <div>进入<span>随意邮小程序</span></div>
        </div>
      </div>
      <div class="bottombox">
        <div style='padding-right: 6px;'>
          <img
            :src="commonData?commonData.syyservice[0].logo_url:''"
            alt=""
          >
          <div>扫码咨询<span>客服</span></div>
        </div>
        <div>
          <div style="color: #616161; margin-bottom: 8px;">
            <div>备注：</div>
            <div>1.'随意邮'客服电话及客服微信号为人工答疑。</div>
          </div>
          <div>客服电话（<span>中国</span>）</div>
          <div><span>{{ commonData?commonData.syytel[0].content:'' }}</span></div>
        </div>
      </div>
    </div>
    <div
      class="qrcodeBox3"
      v-cloak
    >
      <div class="leftbox">
        <div style="margin-bottom: 20px;">
          <img
            :src="commonData?commonData.supicode[0].logo_url:''"
            alt=""
          >
          <div>扫码关注<span>公众号</span></div>
        </div>
        <div>
          <img
            :src="commonData?commonData.supiservice[0].logo_url:''"
            alt=""
          >
          <div>扫码咨询<span>客服</span></div>
        </div>
      </div>
      <div class="rightbox">
        <div class="appbox">
          <img
            :src="commonData?commonData.supiapp[0].logo_url:''"
            alt=""
          >
          <div>扫描二维码<span></span></div>
          <div>进入<span>随意邮小程序</span></div>
        </div>
        <div style="display:flex; margin:10px 0;">
          <img
            :src="commonData?commonData.supiandroid[0].logo_url:''"
            alt=""
            style="width:90px;height:90px;"
          >
          <img
            :src="commonData?commonData.supiios[0].logo_url:''"
            alt=""
            style="width:90px;height:90px;"
          >
        </div>
        <div>扫码<span>下载APP</span>(安卓/IOS)</div>

      </div>
    </div>
    <div
      class="qrcodeBox"
      v-cloak
    >
      <div
        class="rightTop"
        :key="1"
      >
        <img
          :src="commonData?commonData.fastgoCode[0].logo_url:''"
          alt=""
        >
        <p>{{ commonData?commonData.fastgoCode[0].content:'' }}</p>
        <p>官方微信公众号</p>
      </div>
      <div
        class="rightCenter"
        :key="2"
      >
        <p>客服电话（<span>中国</span>）:<span>{{ commonData?commonData.tel[0].content:'' }}</span></p>
        <span>客服微信号：</span>
        <div class="headImg">
          <img
            :src="item.logo_url"
            alt=""
            v-for="(item,index) in commonData.service"
            :key="index"
          >
        </div>
      </div>
      <div
        class="rightBottom"
        :key="3"
      >
        <p>备注:</p>
        <ol>
          <li>{{ commonData?commonData.fastgoCode[0].content:'' }}（接受身份证图片，客服，查询）</li>
          <li>客服电话及客服微信号为人工答疑，不收身份证，北京时间为8:30-17:30周一~周五，周六轮值，周日、节假日除外</li>
        </ol>
      </div>
    </div>
    <div
      class="headRightWrap"
      @mouseover="enter"
      @mouseout="leave"
      style="cursor:pointer"
    >
      <img
        src="../assets/kefu.png"
        alt=""
      >
      <p>联系我们</p>
    </div>

    <div
      class="headRightWrap headRightWrap2"
      @mouseover="enters"
      @mouseout="leaves"
      style="cursor:pointer"
    >
      <img
        src="../assets/syylogo.png"
        alt=""
      >
      <p>随意邮</p>
    </div>
    <div
      class="headRightWrap headRightWrap3"
      @mouseover="entersupi"
      @mouseout="leavesupi"
      style="cursor:pointer"
    >
      <img
        src="../assets/supilogo.png"
        alt=""
      >
      <p>速派集运</p>
    </div>

    <div
      class="barcode"
      v-if="flag"
      @click="cancel_wx_login"
    >
      <div
        class="card"
        id="qrcode"
        ref="code"
      >
        <wxlogin
          :appid="scan.appId"
          :redirect_uri="redirect_uri"
          :scope="scope"
        ></wxlogin>
      </div>
    </div>
    <!--状态为isregister=1选择绑定方式弹框-->
    <div
      class="binding_wrap"
      v-if="binding_flag"
    >
      <div class="binding_content">
        <img
          src="../assets/fastgoLogo.png"
          alt=""
        >
        <div class="not_complete">您的账号信息不完整，为了确保您能正常使用我们的服务，请您补全您的基本信息或绑定已有账号</div>
        <div class="account_yes">
          <span>有账号 绑定账号</span>
          <div @click="binding_account">绑定账号</div>
        </div>
        <div class="account_no">
          <span>无账号 补全信息</span>
          <div @click="binding_to_register">补全信息</div>
        </div>

      </div>

    </div>
    <!--绑定账号弹框-->
    <div
      class="bingding_message"
      v-if="binding_message"
    >
      <div class="message_content">
        <div
          class="close"
          @click="close_binding"
        >✖</div>
        <img
          src="../assets/fastgoLogo.png"
          alt=""
          class="logo_binding"
        >
        <div class="binding_phone">
          <img
            src="../assets/phone.png"
            alt=""
          >
          <input
            type="text"
            v-model="binding_user.account"
            placeholder="手机号/用户名"
          >
        </div>
        <div class="binding_password">
          <img
            src="../assets/passwordIcon.png"
            alt=""
          >
          <input
            type="password"
            v-model="binding_user.pwd"
            placeholder="请输入密码"
          >
        </div>
        <div
          class="binding_button"
          @click="commit_binding"
        >绑定</div>
      </div>
    </div>
    <tips :flag="tipsFlag"></tips>

    <!--整体服务协议-->
    <serviceAgreement v-if="serviceAgreementStatus"></serviceAgreement>

  </div>

</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper"
import { UrlSearch, get_all_banner } from "../services/selectSide"
import { mapState } from 'vuex'
import wxlogin from 'vue-wxlogin'
import Broadcast from '../components/Notice'
import Article from '../components/Article'
import tips from '../components/tips'
import serviceAgreement from '../components/serviceAgreement'
import { login, userLogOut, isRegister, binding, getWx } from '@/services/home'

export default {
  name: 'Home',
  props: {},
  components: {
    swiper,
    swiperSlide,
    wxlogin,
    Broadcast,
    Article,
    tips,
    serviceAgreement
  },
  data() {
    return {
      showArticle: false,
      noticeContent: '',
      bannerList: [],
      commonObj: {},
      swiperOptions: {
        loop: true,
        slidesPerView: 4,
        slidesPerGroup: 1,
        autoplay: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
      },
      swiperOption: {
        autoplay: {
          delay: 10000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
      },
      user: {
        tel: '',
        pwd: '',
        view: ''
      },
      // 微信扫一扫弹框
      flag: false,
      // snsapi_userinfo
      scope: "snsapi_login",
      billNumber: '',

      binding_flag: false,
      // 绑定信息弹框标志
      binding_message: false,
      binding_user: {
        account: '',
        pwd: '',
        openid: '',
        nick_name: '',
        avatar: '',
        sex: '',
        unionid: ''
      },
    }
  },
  computed: {
    ...mapState({
      scan: state => state.scan,
      isload: state => state.isload,
      userInfo: state => state.userInfo,
      redirect_uri: state => encodeURIComponent(state.scan.url),
      wx_code: state => state.wx_code,
      register_param: state => state.register_param,
      commonData: state => state.commonData,
      redirectUrl: state => state.redirectUrl,
      tipsFlag: state => state.tipsFlag,
      serviceAgreementStatus: state => state.serviceAgreement,
      consoleUrl: state => state.consoleUrl,
      erpUrl: state => state.erpUrl
    }),
  },
  methods: {
    openCookie() {
      this.$store.commit('setCookieBox', true)
    },
    openServiceAgreement() {
      this.$store.commit('setServiceAgreement', true)
    },
    clickNotice(data) {
      if (data) {
        if (data.content) {
          this.noticeContent = data
          this.showArticle = true
        } else {
          this.showArticle = false
        }
      } else {
        this.showArticle = false
      }
    },
    billChange(e) {
      this.billNumber = e.target.value;
      this.$store.commit('changeValue', e.target.value)
    },
    searchBill() {
      if (this.billNumber) {
        this.$store.commit('changeBtn', true);
        this.$router.push({ path: '/WaybillQuery' });
      } else {
        this.$store.commit('setTipsFlag', { tips: '您还没有输入订单号', search_flag: true, tipsCode: 2 });
      }
    },
    tabChange(type) {
      this.$store.commit('tabChange', type);
    },
    userLogin() {
      if (this.user.tel == '') {
        this.$store.commit('setTipsFlag', { tips: '您还没有填写手机号/用户名', search_flag: true, tipsCode: 2 });
      } else if (this.user.pwd == '') {
        this.$store.commit('setTipsFlag', { tips: '您还没有填写密码', search_flag: true, tipsCode: 2 });
      } else {
        this.$store.commit('setTipsFlag', { tips: '正在登录请稍等', search_flag: true, tipsCode: 3, handle: true });
        var content = {
          account: this.user.tel,
          pwd: this.user.pwd
        }
        login({ content: JSON.stringify(content) }).then(res => {
          if (res.code == 1) {
            location.href = this.redirectUrl.split('?')[0]
          } else {
            this.$store.commit('setTipsFlag', { tips: res.message, search_flag: true, tipsCode: 2 });
          }
        })
      }
    },
    checkLogin() {
      isRegister({ url: this.redirectUrl }).then(res => {
        if (res.code == 2) {
          this.$store.commit('changeLoad', true);
        } else {
          this.$store.commit('changeLoad', false);
          this.$store.commit('changeUser', { data: res.data });
        }
      })
    },
    logout() {
      userLogOut().then(res => {
        if (res.code == 1) {
          location.href = this.redirectUrl.split('?')[0]
        } else {
          this.$store.commit('setTipsFlag', { tips: res.message, search_flag: true, tipsCode: 2 });
        }
      })
    },
    binding_account() {
      var that = this;
      that.binding_message = true;
      that.binding_flag = false;
    },
    binding_to_register() {
      var that = this;
      that.$router.push({ path: '/UserRegistration' });
    },
    close_binding() {
      var that = this;
      that.binding_message = false;
      that.binding_flag = true;
    },
    commit_binding() {
      var that = this;
      that.binding_user.openid = that.register_param.data.openid;
      that.binding_user.nick_name = that.register_param.data.nick_name;
      that.binding_user.avatar = that.register_param.data.avatar;
      that.binding_user.sex = that.register_param.data.sex;
      that.binding_user.unionid = that.register_param.data.unionid;
      binding({ content: JSON.stringify(that.binding_user) }).then(res => {
        if (res.code == 1) {
          that.$store.commit('setTipsFlag', { tips: '绑定成功', search_flag: true, tipsCode: 1 });
          setTimeout(() => {
            location.href = that.redirectUrl.split('?')[0]
          }, 2000)
        } else {
          that.$store.commit('setTipsFlag', { tips: res.message, search_flag: true, tipsCode: 2 });
        }
      })
    },
    getWxParam() {
      getWx().then(res => {
        this.flag = true;
        this.$store.commit('changeScan', res.data)
      })
    },
    cancel_wx_login() {
      this.flag = false;
    },
    order() {
      window.open(this.consoleUrl + "?addrType=1&&uid=" + this.userInfo.uid, "_blank");
    },
    entry() {
      if (document.querySelector('.agreeService input').checked) {
        window.open(this.erpUrl, 'blank')
      } else {
        this.$store.commit('setTipsFlag', { tips: '请勾选同意服务协议以及隐私政策~~', search_flag: true, tipsCode: 2 });
      }
    },
    enter() {
      document.querySelector('.qrcodeBox').classList.add('active');
      document.querySelector('.qrcodeBox').style.zIndex = '9999';
    },
    leave() {
      document.querySelector('.qrcodeBox').classList.remove('active');
      document.querySelector('.qrcodeBox').style.zIndex = '99';
    },
    enters() {
      document.querySelector('.qrcodeBox2').classList.add('active');
      document.querySelector('.qrcodeBox2').style.zIndex = '9999';
    },
    leaves() {
      document.querySelector('.qrcodeBox2').classList.remove('active');
      document.querySelector('.qrcodeBox2').style.zIndex = '99';
    },
    entersupi() {
      document.querySelector('.qrcodeBox3').classList.add('active');
      document.querySelector('.qrcodeBox3').style.zIndex = '9999';
    },
    leavesupi() {
      document.querySelector('.qrcodeBox3').classList.remove('active');
      document.querySelector('.qrcodeBox3').style.zIndex = '99';
    },
  },
  created() {
    get_all_banner().then((res) => {
      if (res.code == 1) {
        this.bannerList = res.data
      }
    })
  },
  mounted() {
    var param = new UrlSearch();
    var that = this;
    if (param.code) {
      that.$store.commit('get_wx_code', param.code);
      // getWxParam
      that.$store.dispatch('commit_code', that.wx_code).then(() => {
        if (that.register_param.code == 1) {
          // 为一必须去绑定
          if (that.register_param.data.is_register == 1) {
            that.binding_flag = true;
          } else {
            that.checkLogin()
          }
        } else {
          this.$store.commit('setTipsFlag', { tips: that.register_param.message, search_flag: true, tipsCode: 2 });
        }
      });
    } else {
      that.checkLogin()
    }
  }
}
</script>
<style scoped lang="scss">
.home-wrapper {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

header {
  position: relative;
  background: #f2f1f1;
  min-height: 400px;
  .swiper {
    width: 1200px;
    height: 400px;
    margin: 0;
    .swiperSlide {
      width: 1200px;
      height: 100%;
      img {
        width: 1200px;
        height: 100%;
      }
    }
    .swiper-pagination {
      .swiper-pagination-bullet.swiper-pagination-bullet-active {
        background: #000 !important;
        opacity: 0.2;
      }
      .swiper-pagination-bullet {
        background: #ccc;
      }
    }
  }
  .top {
    position: absolute;
    left: 0;
    top: 40px;
    width: 100%;
    height: 50px;
    background: rgba(0, 0, 0, 0.8);
    .list {
      width: 55%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      list-style: none;
      color: #fff;
      li {
        margin: 0 35px;
        line-height: 27px;
      }
      li.active {
        color: $bg-color;
        border-bottom: 2px solid #fff;
      }
    }
  }
  .logo {
    position: absolute;
    top: 0;
    left: 20%;
    z-index: 999;
    background: #000;
    padding: 10px;
    box-sizing: border-box;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }
}

.headRightWrap {
  width: 50px;
  height: 180px;
  background: #c22e2c;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 30%;
  right: 0;
  z-index: 9999;
  img {
    width: 30px;
  }
  p {
    text-align: center;
    width: 20px;
    margin-top: 10px;
  }
}

.headRightWrap2 {
  height: 140px;
  left: 0;
}

.headRightWrap3 {
  top: calc(30% + 150px);
  height: 150px;
  left: 0;
}

.qrcodeBox {
  background: #fff;
  width: 300px;
  height: 350px;
  padding: 20px;
  box-sizing: border-box;
  box-sizing: -2px 2px 0 0 #eee;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s;
  transition-delay: 0.1s;
  position: fixed;
  top: 20%;
  right: 50px;
  z-index: 9999;
}
.qrcodeBox2 {
  background: #fff;
  width: 310px;
  height: 380px;
  padding: 20px;
  box-sizing: border-box;
  box-sizing: -2px 2px 0 0 #eee;
  box-shadow: 0px 2px 10px 3px rgba(0, 0, 0, 0.13);
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s;
  transition-delay: 0.1s;
  position: fixed;
  top: 20%;
  left: 50px;
  z-index: 9999;
  text-align: center;

  span {
    color: red;
  }

  .topbox,
  .bottombox {
    display: flex;
  }

  .topbox {
    border-bottom: 2px dashed #999;
    align-items: center;
    padding-bottom: 10px;
  }

  .bottombox {
    padding-top: 10px;
    align-items: flex-start;
  }
}

.qrcodeBox3 {
  background: #fff;
  width: 340px;
  height: 360px;
  padding: 20px;
  box-sizing: border-box;
  box-sizing: -2px 2px 0 0 #eee;
  box-shadow: 0px 2px 10px 3px rgba(0, 0, 0, 0.13);
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s;
  transition-delay: 0.1s;
  position: fixed;
  top: calc(20% + 140px);
  left: 50px;
  z-index: 9999;
  display: flex;
  text-align: center;

  span {
    color: red;
  }

  .leftbox,
  .rightbox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .rightbox {
    .appbox {
      padding-bottom: 10px;
      border-bottom: 2px dashed #999;
    }
  }
}

.active {
  opacity: 1;
  visibility: visible;
  transition: opacity 0.2s;
  transition-delay: 0.1s;
  z-index: 9999;
}

.rightTop {
  float: right;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 100px;
    height: 100px;
  }
  p {
    margin: 3px 0;
    font-size: 13px;
    letter-spacing: 1px;
  }
}

.rightCenter {
  float: left;
  width: 138px;
  span {
    color: #c22e2c;
    font-size: 16px;
    line-height: 25px;
  }
  p {
    word-break: break-all;
    font-size: 16px;
    line-height: 25px;
  }
  .headImg {
    height: 15%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-top: 5%;
    img {
      width: 80px;
      height: 80px;
      margin-top: 20px;
    }
  }
}

.rightBottom {
  width: 170px;
  float: right;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 12px;
  margin-top: -110px;
  color: #727272;
  border-top: 1px dashed #e1e1e1;
  padding-top: 20px;
  box-sizing: border-box;
  p {
    margin-left: 17px;
  }
  ol {
    list-style-type: decimal;
    li {
      list-style-position: inside;
      text-indent: -17px;
      margin-left: 17px;
    }
  }
}

.news_broadcast {
  width: 1040px;
  margin: 40px auto;
}

.side {
  width: 1040px;
  height: 540px;
  margin: 0 auto;
  margin-top: 40px;
  position: relative;
  background: #f2f1f1;
  padding: 10px 40px;
  box-sizing: border-box;
  border-radius: 10px;
  padding-top: 95px;
  /*display: flex;*/
  /*justify-content: space-around;*/
  /*align-items: center;*/
  z-index: 999;
  border: 1px solid #e5e5e5;
  box-shadow: -2px 0 0 0 #e1e1e1;
  .wraps {
    /*display: flex;*/
    /*justify-content: space-around;*/
    /*align-items: center;*/
    background: rgb(245, 245, 245);
    margin-top: -10px;
    .waybill,
    .user,
    .card {
      position: relative;
      border: 1px solid $bg-color;
      float: left;
      > img {
        position: absolute;
        top: -30px;
        left: 40%;
      }
    }
    .waybill,
    .user {
      height: 370px;
      width: 240px;
      /*display: flex;*/
      /*flex-direction: column;*/
      /*align-items: center;*/
      background: #fff;
      position: relative;
      > a {
        width: 100%;
        height: 70px;
        background: $bg-color;
        color: #fff;
        line-height: 68px;
        padding-left: 19px;
        font-size: 20px;
        box-sizing: border-box;
        text-align: center;
        display: block;
      }
      > p {
        width: 100%;
        height: 70px;
        background: $bg-color;
        color: #fff;
        line-height: 68px;
        padding-left: 19px;
        font-size: 20px;
        box-sizing: border-box;
        text-align: center;
        cursor: pointer;
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
      }
      > .searchBox {
        height: 300px;
        box-sizing: border-box;
      }
      .users {
        width: auto;
      }
    }
    .waybill {
      > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        textarea {
          width: 212px;
          height: 147px;
          border-radius: 10px;
          padding: 10px;
          box-sizing: border-box;
          border: 2px solid #dcdcdc;
          resize: none;
          outline: none;
        }
        button {
          width: 111px;
          height: 43px;
          border: none;
          border-radius: 10px;
          color: #fff;
          margin-top: 30px;
          background: #333333;
          font-size: 15px;
          line-height: 43px;
          text-align: center;
          outline: none;
        }
      }
    }
    .card {
      width: 420px;
      margin: 0 20px;
      display: flex;
      flex-direction: column;
      background: #fff;
      dl {
        display: flex;
        width: 100%;
        height: 300px;
        padding: 0 20px;
        box-sizing: border-box;
        dt {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-right: 25px;
          img {
            width: 100px;
            height: 77px;
            margin: 10px 0;
          }
        }
        dd {
          flex: 1;
          height: 100%;
          ol {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-left: 25px;
            box-sizing: border-box;
            li {
              background: #fff;
              color: #6a6a6b;
              line-height: 20px;
              font-size: 16px;
              word-break: break-all;
              margin: 12px 0;
            }
          }
        }
      }
      > a {
        width: 100%;
        height: 68px;
        background: $bg-color;
        color: #fff;
        font-size: 20px;
        box-shadow: 0 2px 2px #9c9c9c;
        line-height: 68px;
        box-sizing: border-box;
        text-align: center;
        display: block;
      }
    }
    .user {
      img {
        width: 58px;
        height: 58px;
        border-radius: 100%;
      }
      .userLoad {
        /*display: flex;*/
        /*flex-direction: column;*/
        /*align-items: center;*/
        /*justify-content: center;*/
        width: 100%;
        padding-top: 27px;
        text-align: center;
        input {
          width: 210px;
          height: 40px;
          margin: 5px 0;
          padding: 0 5px;
          box-sizing: border-box;
          border: 2px solid #dcdcdc;
          border-radius: 10px;
          outline: none;
        }
        .btn {
          width: 210px;
          height: 32px;
          line-height: 30px;
          text-align: center;
          margin: 5px auto;
          .login {
            width: 80px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            border: none;
            border-radius: 10px;
            color: #fff;
            background: #333333;
            font-size: 16px;
            float: right;
          }
          .register {
            width: 80px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            border: none;
            border-radius: 10px;
            color: #fff;
            background: #7b7b7b;
            font-size: 16px;
            float: left;
          }
        }
        img {
          width: 30px;
          height: 30px;
          margin-top: 5px;
        }
      }
      .users {
        /*flex: 1;*/
        width: 100%;
        text-align: center;
        /*display: flex;*/
        /*flex-direction: column;*/
        /*align-items: center;*/
        p {
          line-height: 40px;
        }
        p:nth-child(1) {
          margin-top: 30px;
        }
        p:nth-child(2) {
          margin-bottom: 5px;
        }
        span {
          width: 150px;
          height: 35px;
          text-align: center;
          line-height: 35px;
          background: #7b7b7b;
          color: #fff;
          border-radius: 5px;
          display: block;
          margin: 10px auto 0;
        }
      }
    }
  }
}

.come {
  width: 1000px;
  margin: 20px auto;
  .comeTop {
    position: relative;
    /*display: flex;*/
    /*flex-direction: column;*/
    /*align-items: center;*/
    /*justify-content: center;*/
    height: 100px;
    letter-spacing: 2px;
    text-align: center;
    p {
      font-size: 17px;
      font-weight: 600;
    }
    h2 {
      color: $bg-color;
      margin-bottom: 5px;
    }
    div {
      width: 80px;
      height: 3px;
      background: $bg-color;
      position: absolute;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
  }
  .comeType {
    width: 100%;
    a {
      display: block;
      width: 40%;
      min-height: 250px;
      margin: 30px 0;
      background: url(../assets/地图1.png) no-repeat 0 0;
      background-size: 100% 100%;
      box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.2);
      border-radius: 5px;
      float: left;
      text-align: center;
      dl {
        width: 100%;
        height: 100%;
        /*display: flex;*/
        /*flex-direction: column;*/
        /*align-items: center;*/
        /*justify-content: center;*/
        padding: 5px;
        box-sizing: border-box;
        dt {
          height: 50%;
          /*display: flex;*/
          /*align-items: flex-end;*/
          /*justify-content: center;*/
          img {
            width: 90px;
            /*height: 80px;*/
            margin-top: 10px;
          }
        }
        dd {
          height: 49%;
          /*width: 320px;*/
          /*border-bottom: 1px solid #b4b3b3;*/
          /*display: flex;*/
          /*flex-direction: column;*/
          /*align-items: center;*/
          /*justify-content: flex-start;*/
          p {
            margin-top: 30px;
            font-size: 19px;
            font-weight: 600;
            letter-spacing: 2px;
            color: #2d2d2d;
          }
          span {
            display: block;
            /*width: 320px;*/
            margin-top: 10px;
            color: #666;
            text-align: center;
            margin-bottom: 10px;
            font-size: 16px;
          }
        }
      }
    }
    a:nth-child(2) {
      background: url(../assets/地图2.png) no-repeat 0 0;
      background-size: 100% 100%;
      margin-left: 20%;
    }
    a:nth-child(3) {
      background: url(../assets/地图3.png) no-repeat 0 0;
      background-size: 100% 100%;
    }
    a:nth-child(4) {
      background: url(../assets/地图4.png) no-repeat 0 0;
      background-size: 100% 100%;
      margin-left: 20%;
    }
  }
}

.strength {
  height: 250px;
  background: url(../assets/backimg6.png) no-repeat 0 0;
  background-size: 100% 100%;
  color: #fff;
  margin-top: 50px;
  .strengthBox {
    width: 1000px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    .strengthTop {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      div {
        width: 80px;
        height: 3px;
        background: $bg-color;
        margin-top: 5px;
      }
    }
    .strengthCont {
      width: 100%;
      display: flex;
      justify-content: space-around;
      div {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        p {
          margin: 5px 0;
        }
        p:nth-child(1) {
          font-size: 25px;
          font-weight: 500;
        }
        p:nth-child(3) {
          font-size: 11px;
        }
      }
    }
  }
}

.chart {
  width: 1000px;
  height: 242px;
  margin: 60px auto 40px;
  .chartIcon {
    height: 242px;
    display: flex;
    img {
      height: 163px;
      flex: 1;
      margin: 0 5px;
    }
    .swiper-pagination {
      bottom: 30px;
      .swiper-pagination-bullet {
        width: 60px;
        height: 30px;
        display: inline-block;
        background: #adafb1;
        margin: 0 5px;
        border-radius: 0;
      }
      .swiper-pagination-bullet-active {
        opacity: 1;
        background-color: $bg-color;
      }
    }
  }
}

.userLogin {
  min-width: 200px;
  height: 50px;
  background: #2e2e2e;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  padding: 0 10px;
  box-sizing: border-box;
  img {
    width: 25px;
    height: 25px;
    margin-right: 5px;
  }
  p {
    font-size: 17px;
    color: #fff;
    /*font-weight: bold;*/
  }
}

.barcode {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  z-index: 99999;
  .card {
    width: 300px;
    height: 400px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -200px;
    margin-left: -150px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.again {
  width: 200px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ccc;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -100px;
  margin-top: -25px;
  z-index: 99999;
  border-radius: 5px;
}

.binding_wrap {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999999;
  .binding_content {
    width: 500px;
    height: 400px;
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    img {
      width: 250px;
      display: block;
      margin: 20px auto;
    }
    .not_complete {
      margin: 40px 20px 10px;
      background: rgb(229, 229, 229);
      color: #393939;
      padding: 5px;
      font-size: 18px;
    }
    .account_yes,
    .account_no {
      height: 60px;
      background: rgb(248, 248, 248);
      margin: 20px 0;
      padding: 0 20px;
      span {
        font-size: 20px;
        color: #393939;
        font-weight: bold;
        line-height: 60px;
      }
      div {
        width: 100px;
        height: 30px;
        margin: 15px 0;
        background: $bg-color;
        border-radius: 5px;
        color: #fff;
        font-weight: bold;
        text-align: center;
        line-height: 30px;
        float: right;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
}

.bingding_message {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999999;

  .message_content {
    width: 400px;
    height: 300px;
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    .close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 24px;
      height: 24px;
      border-radius: 24px;
      font-size: 14px;
      color: #393939;
      text-align: center;
      line-height: 24px;
      background: rgba(0, 0, 0, 0.1);
      padding: 0;
      margin: 0;
      cursor: pointer;
    }
    .logo_binding {
      width: 200px;
      display: block;
      margin: 20px auto 50px;
    }
    div {
      width: 300px;
      height: 40px;
      border-radius: 20px;
      background: rgb(246, 233, 235);
      color: #393939;
      padding: 0 10px;
      margin: 20px auto;
      img {
        width: 20px;
        display: inline-block;
        margin: 9px;
        float: left;
      }
      input {
        width: 260px;
        line-height: 40px;
        display: inline-block;
        margin: 0;
        border: none;
        outline: none;
        background: rgba(0, 0, 0, 0);
        float: left;
        font-size: 16px;
      }
    }
    .binding_button {
      width: 50px;
      height: 30px;
      color: #fff;
      font-weight: bold;
      line-height: 30px;
      background: $bg-color;
      border-radius: 5px;
      margin: 10px auto;
      text-align: center;
      cursor: pointer;
    }
  }
}

.agreeService {
  width: 190px;
  margin-left: 4px;
}

.agreeService input {
  width: 13px !important;
  position: absolute;
  left: 12px;
  top: 2px;
  height: 13px !important;
  margin: 0 !important;
}

.agreeService {
  font-size: 12px;
  color: #7b7b7b;
  text-align: left;
  padding: 0 30px 5px;
  position: relative;
  margin-top: 10px;
  height: auto !important;
}

.underline-text {
  border-bottom: 1px solid #7b7b7b;
  font-size: 9px;
}

.underline-text a {
  color: #7b7b7b;
}

[v-cloak] {
  display: none;
}
</style>
<style>
.swiper-pagination-bullet-active {
  background: #8b8a8a;
}
</style>



// WEBPACK FOOTER //
// src/view/HomeNew.vue